<template>
  <loader :task="task" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import { IntegrationType, ServiceAccount } from '@/iam/types';
import { createServiceAccount } from '.';

interface Data {
  task: Promise<ServiceAccount>|null
}

export default defineComponent({
  emits: ['created'],
  components: {
    Loader,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    integrationType: {
      type: String as () => IntegrationType,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    create(): void {
      this.task = createServiceAccount(this.accountId, this.integrationType);
      this.task.then((serviceAccount) => {
        this.$emit('created', serviceAccount);
      });
    },
  },
  created(): void {
    this.create();
  },
});
</script>
